import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

// Styles
import "index.css";

// Flux Stores
import "store/sys";

ReactDOM.render(
  <>
    <App />
  </>,
  document.getElementById("root")
);
